/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PublicUser
 */
export interface PublicUser {
    /**
     * 
     * @type {string}
     * @memberof PublicUser
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PublicUser
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof PublicUser
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof PublicUser
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof PublicUser
     */
    phone?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PublicUser
     */
    isActive: boolean;
    /**
     * 
     * @type {Date}
     * @memberof PublicUser
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof PublicUser
     */
    updatedAt: Date;
}

/**
 * Check if a given object implements the PublicUser interface.
 */
export function instanceOfPublicUser(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "firstName" in value;
    isInstance = isInstance && "lastName" in value;
    isInstance = isInstance && "email" in value;
    isInstance = isInstance && "isActive" in value;
    isInstance = isInstance && "createdAt" in value;
    isInstance = isInstance && "updatedAt" in value;

    return isInstance;
}

export function PublicUserFromJSON(json: any): PublicUser {
    return PublicUserFromJSONTyped(json, false);
}

export function PublicUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): PublicUser {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'firstName': json['first_name'],
        'lastName': json['last_name'],
        'email': json['email'],
        'phone': !exists(json, 'phone') ? undefined : json['phone'],
        'isActive': json['is_active'],
        'createdAt': (new Date(json['created_at'])),
        'updatedAt': (new Date(json['updated_at'])),
    };
}

export function PublicUserToJSON(value?: PublicUser | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'first_name': value.firstName,
        'last_name': value.lastName,
        'email': value.email,
        'phone': value.phone,
        'is_active': value.isActive,
        'created_at': (value.createdAt.toISOString()),
        'updated_at': (value.updatedAt.toISOString()),
    };
}

